import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useStateRef } from 'app/services';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { useForm } from 'react-hook-form';
const GeofenceGroupForm = forwardRef((props, ref) => {
    var _a, _b;
    const { defaultValues, onSubmit } = props;
    const theme = useTheme();
    const [color, setColor] = useState((_a = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.color) !== null && _a !== void 0 ? _a : theme.palette.primary.main);
    const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(!!defaultValues);
    const { reset, register, setValue, formState, handleSubmit } = useForm({
        defaultValues: {
            name: defaultValues ? defaultValues.name : '',
            color: defaultValues ? (_b = defaultValues.color) !== null && _b !== void 0 ? _b : theme.palette.primary.main : theme.palette.primary.main,
        },
    });
    const handleColorChange = (value) => {
        setColor(value);
        setValue('color', value, { shouldDirty: true });
    };
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => onSubmit({
                name: data.name,
                color: data.color,
            }))();
        },
    }));
    useLayoutEffect(() => {
        if (firstUpdateRef.current !== undefined) {
            setTimeout(() => setFirstUpdate(undefined), theme.transitions.duration.shorter);
        }
    }, [firstUpdateRef.current]);
    useEffect(() => {
        var _a, _b;
        if (defaultValues) {
            reset({
                name: defaultValues.name,
                color: (_a = defaultValues.color) !== null && _a !== void 0 ? _a : theme.palette.primary.main,
            });
            setColor((_b = defaultValues.color) !== null && _b !== void 0 ? _b : theme.palette.primary.main);
        }
    }, [defaultValues]);
    return (React.createElement("form", null,
        React.createElement(FormControl, { error: !!formState.errors.name, margin: 'normal', variant: 'outlined', fullWidth: true },
            React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
            React.createElement(OutlinedInput, Object.assign({ label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435', placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B', notched: firstUpdate, fullWidth: true }, register('name', {
                pattern: /^([A-Za-zА-Яа-я0-9_\-\s]{3,255})$/iu,
                required: true,
                minLength: 3,
            }))),
            React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0438 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432")),
        React.createElement(FormControl, { error: !!formState.errors.color, margin: 'normal', variant: 'outlined', fullWidth: true, sx: (theme) => ({
                marginBottom: theme.spacing(0),
                '.MuiOutlinedInput-notchedOutline': {
                    borderBottom: '0',
                    borderBottomLeftRadius: '0',
                    borderBottomRightRadius: '0',
                },
                '.MuiOutlinedInput-root': {
                    color: 'text.primary',
                },
                '.MuiOutlinedInput-input': {
                    WebkitTextFillColor: 'currentColor',
                },
            }) },
            React.createElement(InputLabel, { disableAnimation: true }, "\u0426\u0432\u0435\u0442 \u0437\u0430\u043B\u0438\u0432\u043A\u0438"),
            React.createElement(OutlinedInput, { label: '\u0426\u0432\u0435\u0442 \u0437\u0430\u043B\u0438\u0432\u043A\u0438', placeholder: '\u0426\u0432\u0435\u0442 \u0437\u0430\u043B\u0438\u0432\u043A\u0438', value: color, disabled: true, notched: true, fullWidth: true })),
        React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true, sx: (theme) => ({
                marginTop: '0',
                '.react-colorful': {
                    width: '100%',
                    borderBottomLeftRadius: theme.shape.borderRadius * 2,
                    borderBottomRightRadius: theme.shape.borderRadius * 2,
                },
                '.react-colorful__saturation': {
                    boxShadow: 'inset 0px -1px 0px 1px rgb(0 0 0 / 15%)',
                    borderRadius: '0',
                },
                '.react-colorful__last-control': {
                    borderRadius: '0',
                    borderBottomLeftRadius: theme.shape.borderRadius * 2,
                    borderBottomRightRadius: theme.shape.borderRadius * 2,
                },
            }) },
            React.createElement(HexColorPicker, { color: color, onChange: handleColorChange }),
            React.createElement(FormHelperText, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0446\u0432\u0435\u0442 \u0438\u0437 \u043F\u0430\u043B\u0438\u0442\u0440\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0431\u0443\u0434\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0446\u0432\u0435\u0442\u0430 \u0437\u0430\u043B\u0438\u0432\u043A\u0438 \u0433\u0435\u043E\u0437\u043E\u043D\u044B \u043D\u0430 \u043A\u0430\u0440\u0442\u0435."))));
});
GeofenceGroupForm.displayName = 'GeofenceGroupForm';
export default GeofenceGroupForm;
